


























import {Component} from 'vue-property-decorator';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Chart } from "@amcharts/amcharts4/charts";
am4core.useTheme(am4themes_animated);

import CountItemPayload from '@/models/payloads/CountItemPayload';
import CountItemResponse from '@/models/responses/CountItemResponse';
import {findCoordinate, findCoordinates} from '@/repositories/local/CountLocal';
import ChartData from '@/models/ChartData';
import {getEntities} from '@/repositories/api/CountApi';
import CountComponent from '@/components/pages/home/CountComponent.vue';
import ChartDataItem from '@/models/ChartDataItem';
@Component
export default class ChartComponent extends CountComponent {
  protected loading = false;
  protected items: CountItemResponse[] = [];
  protected finder: Function = findCoordinate;
  protected payload: CountItemPayload[] = findCoordinates();
  protected color: string = 'primary';

  private chart: Chart | null = null;
  protected propData = new ChartData([]);
  title = '';
  description = '';
  propLabels = '';


  get computedData(): ChartData {
    let chartData = new ChartData([]);

    this.items.forEach(item => {
      chartData.items.push({category: item.name, value: item.count} as ChartDataItem)
    });

    return chartData;
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  drawChart() {
    this.chart = am4core.create("chart", am4charts.PieChart);

    if (
      this.computedData &&
      this.computedData.items &&
      this.computedData.items.length &&
      this.chart
    ) {
      this.chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

      this.chart.data = this.computedData.items;

      //@ts-ignore
      if (this.chart.series) {
        //@ts-ignore
        let series = this.chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        series.dataFields.category = "category";

        //@ts-ignore
        this.chart.innerRadius = am4core.percent(30);

        series.slices.template.stroke = am4core.color("#fff");
        series.slices.template.strokeWidth = 2;
        series.slices.template.strokeOpacity = 1;
        // change the cursor on hover to make it apparent the object can be interacted with
        series.slices.template.cursorOverStyle = [
          {
            property: "cursor",
            value: "pointer"
          }
        ];

        series.alignLabels = false;
        series.labels.template.bent = true;
        series.labels.template.radius = 3;
        series.labels.template.padding(0, 0, 0, 0);

        series.ticks.template.disabled = true;

        let shadow = series.slices.template.filters.push(
          new am4core.DropShadowFilter()
        );
        shadow.opacity = 0;

        let hoverState = series.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

        let hoverShadow = hoverState.filters.push(
          new am4core.DropShadowFilter()
        );
        hoverShadow.opacity = 0.7;
        hoverShadow.blur = 5;

        // Add a legend
        this.chart!.legend = new am4charts.Legend();

        this.chart!.data = this.computedData.items;
      }
    }
  }

  async mounted() {
    this.loading = true;

    try {
      const response = await getEntities(this.payload);
      if (response.error == 'success') {
        this.items = response.data as CountItemResponse[]
      }
    } catch (e) {
      console.log(e);
    }

    this.loading = false;

    this.drawChart()
  }
}
